import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ScrollToTop } from './ScrollToTop.jsx';
import './App.css';
import Hero from './components/Hero.jsx';
import Header from './components/Header/Header.jsx';
import Footer from './components/Footer/Footer.jsx';
import AtYourService from './components/AtYourService/AtYourService.jsx';
import DetailBodios from './components/MenuDetail/DetailBodios.jsx';
import About from './components/About/AboutUs.jsx';
import YakDetail from './components/YaKDetail/YakDetail.jsx';
import Social from './components/Social/Social.jsx';
import { CollectionPage } from './components/Category/CollectionPage.jsx';
import { Artisan } from './components/Artisan/Artisan.jsx';
import BoutiqueHeader from './components/BoutiqueHeader/BoutiqueHeader.jsx';
import InsideJournalSlider from './components/Journal/InsideJournalSlider.jsx';
import JournalLayout from './components/Journal/JournalLayout.jsx';
import { ProductDetailPage } from "./components/Category/ProductDetailPage.jsx";
import CartPage from './components/Cart/CartPage.jsx';
import CheckoutPage from './components/Cart/CheckoutPage.jsx';
import SuccessPage from "./components/Cart/SuccessPage";
import FailPage from "./components/Cart/FailPage";
import { CartProvider } from './context/CartContext';
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import YakTrekSection from './components/YakTrekSection.jsx';
import ShippingPolicy from './components/ShippingPolicy.jsx';
import FallWinterSignature from './components/Fall/FallWinterSignature.jsx';
import LooksEditorialSection from './components/LooksEditorialSection.jsx';
import { ImageGallery } from './components/Three/ImageGallery.jsx';

function App() {
  return (
    <Router>
      <ScrollToTop />
      <CartProvider>
        <div className="App mx-auto w-full">
          <Routes>
            {/* Home - transparent header */}
            <Route path="/" element={
              <>
                <Header />
                <Hero />
                <FallWinterSignature /> 
                <ImageGallery/>
                <LooksEditorialSection />
                <YakTrekSection />
                <BoutiqueHeader />
                <Artisan />
                <InsideJournalSlider />
                <AtYourService />
              </>
            } />
            
            {/* Other pages - white header */}
            <Route path="/bodios" element={<><Header variant="white" /><DetailBodios /></>} />
            <Route path="/journal" element={<><Header variant="white" /><JournalLayout /></>} />
            <Route path="/about" element={<><Header variant="white" /><About /></>} />
            <Route path="/yak" element={<><Header variant="white" /><YakDetail /></>} />
            <Route path="/social" element={<><Header variant="white" /><Social /></>} />
            <Route path="/category/:category" element={<><Header variant="white" /><CollectionPage /></>} />
            <Route path="/product/:productId" element={<><Header variant="white" /><ProductDetailPage /></>} />
            <Route path="/cart" element={<><Header variant="white" /><CartPage /></>} />
            <Route path="/checkout" element={<><Header variant="white" /><CheckoutPage /></>} />
            <Route path="/success" element={<SuccessPage />} />
            <Route path="/fail" element={<FailPage />} />
            <Route path="/shipping-policy" element={<ShippingPolicy />} />
          </Routes>
          <Footer />
          <ToastContainer position="top-center" />
        </div>
      </CartProvider>
    </Router>
  );
}

export default App;